/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_No_Templates_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a new template to get started." |
*
* @param {Compliance_No_Templates_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_no_templates_description = /** @type {((inputs?: Compliance_No_Templates_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_No_Templates_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle eine neue Vorlage, um zu beginnen.")
	return /** @type {LocalizedString} */ ("Create a new template to get started.")
});